import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import ClientInformation from './components/ClientInformation';
import PublicProcurementObject from './components/PublicProcurementObject';
import RequestForApprovalObject from './components/RequestForApprovalObject';
import GeneralContractor from './components/GeneralContractor';
import ParentSubcontractorsList from './components/ParentSubcontractorsList';
import SubcontractorDetails from './components/SubcontractorDetails';
import SubcontractedServices from './components/SubcontractedServices';
import SubcontractedServicesPrice from './components/SubcontractedServicesPrice';
import PaymentTerms from './components/PaymentTerms';
import SubcontractorContractDuration from './components/SubcontractorContractDuration';
import SubcontractorSwornStatement from './components/SubcontractorSwornStatement';
import AssignmentOrPledge from './components/AssignmentOrPledge';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function PublicProcurementFormView(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      to: `/request/${props.rfa?.id}`,
      children: /*#__PURE__*/_jsxs("button", {
        className: "inline-container large link my-4",
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "arrow-left",
          color: "paragraph-light"
        }), /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.backToRequest"
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-container",
      children: /*#__PURE__*/_jsx("h1", {
        className: "",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.titles.form"
        })
      })
    }), /*#__PURE__*/_jsx(ClientInformation, {
      projectPublicProcurementData: props.projectPublicProcurementData,
      client: props.projectPublicProcurementData.client
    }), /*#__PURE__*/_jsx(PublicProcurementObject, {
      projectPublicProcurementData: props.projectPublicProcurementData
    }), /*#__PURE__*/_jsx(RequestForApprovalObject, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(GeneralContractor, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(ParentSubcontractorsList, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(SubcontractorDetails, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(SubcontractedServices, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(SubcontractedServicesPrice, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(PaymentTerms, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(SubcontractorContractDuration, {
      rfa: props.rfa,
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(SubcontractorSwornStatement, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx(AssignmentOrPledge, {
      publicProcurementData: props.publicProcurementData,
      onChange: props.updatePublicProcurementData
    }), /*#__PURE__*/_jsx("div", {
      className: "actions col-12 inline-container space-between pb-3",
      children: /*#__PURE__*/_jsxs("button", {
        className: "large cta inline-container",
        type: "submit",
        disabled: props.loading || !props.submitAllowed,
        onClick: props.onSubmit,
        children: [/*#__PURE__*/_jsx(Translate, {
          value: "action.confirm"
        }), /*#__PURE__*/_jsx(Icon, {
          icon: props.loading ? 'loader' : 'check'
        })]
      })
    })]
  });
}
PublicProcurementFormView.defaultProps = {
  loading: false,
  submitAllowed: false
};
PublicProcurementFormView.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  rfa: PropTypes.object.isRequired,
  projectPublicProcurementData: PropTypes.object.isRequired,
  publicProcurementData: PropTypes.object.isRequired,
  updatePublicProcurementData: PropTypes.func.isRequired,
  submitAllowed: PropTypes.bool
};
export default PublicProcurementFormView;